<template>
<div class="chapter">
<div class="inner_page">
<h1 class="block_13" id="id_Toc159854090">Book One</h1>
<p class="block_14" id="calibre_pb_6"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?1154ffc8